import React from 'react';

const PassingDataTutorial = () => {
  return <div>
  TODO
  </div>;
}

export default PassingDataTutorial;